export const agreementKeys = {
  all: () => ['partner-agreement'] as const,
  url: (applicationId?: string) =>
    [...agreementKeys.all(), 'url', applicationId] as const,
};
